// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".2c20ade2c4d4dc266fbb95aa702131b3e973649f.chunk.bundle.js";
};